<template>
  <div class="bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end pt-4 pl-3 pr-3 mb-4">
      <div class="d-flex flex-column">
        <h5 class="mb-1">Sizing</h5>
        <p class="text-gray-500">Use the <span class="text-danger">size</span> prop to control the size of the input fields</p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : viewSizing === 'preview'}" @click="viewSizing = 'preview'">Preview</b-button>
        <b-button :class="{'active' : viewSizing === 'code'}"  @click="viewSizing = 'code'">Code</b-button>
      </ButtonGroup>
    </div>

    <CodePreviewViewer :viewMode="viewSizing" :codeSample="require('@/components/local/Input/input_sizing.js').default">
      <template v-slot:preview>
        <div class="w-100">         
          <h5 class="mb-4"><b>Default</b></h5> 
          <Input label="Small" size="sm" class="w-100 mb-2"></Input>
          <Input label="Medium (Default)" class="w-100 mb-2"></Input>
          <Input label="Large" size="lg" class="w-100 mb-2"></Input>
        
          <h5 class="mt-5 mb-4"><b>Inline</b></h5> 
          <Input label="Small" size="sm" placeholder="Click here" class="w-100 mb-2" inline></Input>
          <Input label="Medium (Default)" placeholder="Click here" class="w-100 mb-2" inline></Input>
          <Input label="Large" placeholder="Click here" size="lg" class="w-100 mb-2" inline></Input>
        </div>
      </template>
    </CodePreviewViewer>
  </div>
</template>
 
<script>
import Input from '@/components/export/Input/Input'
import ButtonGroup from '@/components/export/ButtonGroup/ButtonGroup'
import CodePreviewViewer from '@/components/local/CodePreviewViewer'

export default {
 components: { Input, ButtonGroup, CodePreviewViewer },
 data () {
   return {
     view: 'preview',
     viewSizing: 'preview',
     text:'',
     errors: 'Sample error message here'
   }
 }
}
</script>

